<template lang="pug">
    div
        Table(:columns="tokenColumn" :data="tokenData")
</template>
<script>
import { _getNodeRegisterTokens, regenerateTokens } from "@/api/rest/index";
import { colorNames } from "@/libs/rcmTableFieldsFunction";

export default {
    name: "NodeTokenListTable",
    props: {
        groupName: { type: [String, Array], default: [[], ""] },
        selectedToken: { type: String, default: "" },
        nodeType: { type: String, default: "" },
        tokenData: { type: Array, default: [] },
        regenerateTokenPath: { type: String, default: "" }
    },
    components: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            tokenIndex: 0,
            tokenColumn: [
                {
                    title: "Seq",
                    key: this.nodeType,
                    width: "80",
                    align: "center"
                },
                {
                    title: "Token",
                    key: "token",
                    align: "center",
                    width: "350"
                },
                {
                    title: "Action",
                    key: "active",
                    align: "center",
                    render: (h, params) => {
                        const actionDivArray = [];

                        let canBeUsed = !params.row.active;
                        let isSelected = params.row.token == this.selectedToken;

                        const selectBtn = canBeUsed
                            ? h(
                                  "Button",
                                  {
                                      props: {
                                          type: isSelected ? "primary" : "default"
                                      },
                                      on: {
                                          click: () => {
                                              this.$emit("onSelectToken", params.row.token);
                                          }
                                      }
                                  },
                                  isSelected
                                      ? this.$i18n.t("nodeRegisteration.selected")
                                      : this.$i18n.t("nodeRegisteration.select")
                              )
                            : h("span", this.$i18n.t("nodeRegisteration.inUsed"));

                        var dropdownItems = [
                            {
                                value: "delete",
                                title: this.$t("nodeRegisteration.revoke"),
                                modalTitle: this.$t("nodeRegisteration.revoke"),
                                modalContent: this.$t("nodeRegisteration.revokeRemindText"),
                                disabled: false
                            }
                        ];

                        const moreBtn = h(
                            "Dropdown",
                            {
                                props: {
                                    trigger: "click",
                                    placement: "right",
                                    transfer: true
                                },
                                on: {
                                    "on-click": value => {
                                        var currentItem = dropdownItems.find(e => e.value == value);
                                        this.$Modal.confirm({
                                            title: currentItem.modalTitle,
                                            content: currentItem.modalContent,
                                            okText: this.$i18n.t("rcmtable.confirmText"),
                                            cancelText: this.$i18n.t("rcmtable.cancelText"),
                                            onOk: async () => {
                                                var deleteItem = Object.assign({}, params.row);
                                                console.log(params.row);
                                                delete deleteItem._index;
                                                delete deleteItem._rowKey;

                                                this.tokenIndex = this.tokenData.findIndex(
                                                    token => token.token == params.row.token
                                                );
                                                await this.regenerateToken(params.row.token);
                                            }
                                        });
                                    }
                                }
                            },
                            [
                                h("a", [
                                    h("Button", {
                                        props: {
                                            shape: "circle",
                                            icon: "md-more",
                                            key: params.index
                                        }
                                    })
                                ]),
                                h(
                                    "DropdownMenu",
                                    {
                                        slot: "list"
                                    },
                                    [
                                        dropdownItems.map(function(item) {
                                            return h(
                                                "DropdownItem",
                                                {
                                                    props: {
                                                        name: item.value,
                                                        disabled: item.disabled
                                                    }
                                                },
                                                item.title
                                            );
                                        })
                                    ]
                                )
                            ]
                        );

                        actionDivArray.push(selectBtn);
                        if (this.$store.getters.isAdmin) {
                            actionDivArray.push(moreBtn);
                        }

                        return h(
                            "div",
                            {
                                style: {
                                    display: "flex",
                                    "flex-direction": "row",
                                    "justify-content": "space-around"
                                }
                            },
                            actionDivArray
                        );
                    }
                }
            ]
        };
    },
    methods: {
        async regenerateToken(token) {
            await regenerateTokens({ groupName: this.groupName, nodeType: this.nodeType, token: token })
                .then(response => {
                    this.tokenData[this.tokenIndex].token = response.data.message;
                    this.$emit("reloadData");
                })
                .catch(errors => {
                    console.log(errors);
                });
        }
    },
    mounted() {},
    computed: {}
};
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/NodeRegisteration/NodeTokenListTable.vue